
import {defineComponent} from 'vue';
import WebMidi, { Output, Input } from "webmidi";
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';

export default defineComponent({
  name: "bla",
  components: {
    Button,
    Dropdown
  },
  // A necessary evil to make this work properly with the components
  data() : {
    octaves: number;
    octavesLoaded: number;
    kbMap: Map<string, number>;
    kbDownMap: Map<string, boolean>;
    connecting: boolean;
    connected: boolean;
    roomStatusNotReceived: boolean;
    kbOct: number;
    roomStatusFull: boolean;
    signalingServer: WebSocket | null;
    dc: RTCDataChannel | null;
    pc: RTCPeerConnection | null;
    conn: boolean;
    cand: RTCIceCandidate | null;
    addedCand: boolean;
    candPromise: Promise<void> | null;
    keyMap: Map<number, SVGGElement>;
    midiOut: Output | null;
    midiIn: Input | null;
    midiOuts: Output[];
    midiIns: Input[];
  } {
    return {
      octaves: 8,
      octavesLoaded: 0,
      kbMap: new Map<string, number>([
        ["a", 0],
        ["w", 1],
        ["s", 2],
        ["e", 3],
        ["d", 4],
        ["f", 5],
        ["t", 6],
        ["g", 7],
        ["y", 8],
        ["h", 9],
        ["u", 10],
        ["j", 11],
        ["k", 12],
        ["o", 13],
        ["l", 14],
      ]),
      kbDownMap: new Map<string, boolean>([
        ["a", false],
        ["w", false],
        ["s", false],
        ["e", false],
        ["d", false],
        ["f", false],
        ["t", false],
        ["g", false],
        ["y", false],
        ["h", false],
        ["u", false],
        ["j", false],
        ["k", false],
        ["o", false],
        ["l", false],
      ]),
      connecting: false,
      connected: false,
      kbOct: 4,
      roomStatusNotReceived: true,
      roomStatusFull: false,
      signalingServer: null,
      dc: null,
      pc: null,
      conn: false,
      cand: null,
      addedCand: false,
      candPromise: null,
      keyMap: new Map<number, SVGGElement>(),
      midiOut: null,
      midiIn: null,
      midiOuts: [],
      midiIns: []
    }
  },
  mounted(): void {
    this.refreshDevices(true);

    window.addEventListener("keydown", (e) => {
        if (this.kbMap.has(e.key) && !this.kbDownMap.get(e.key)!) {
          const noteval = this.kbMap.get(e.key)! + 12 * this.kbOct;
          const data = new Uint8Array([
            parseInt("10010000", 2) + 1,
            noteval,
            64
            ]);
          this.highlightKey(noteval, "on", "self");
          this.midiOut?.send(data[0], [data[1], data[2]]);
          this.kbDownMap.set(e.key, true);
          this.dc?.send(data)
        }      
    });

    window.addEventListener("keyup", (e) => {
        if (this.kbMap.has(e.key)) {
            const noteval = this.kbMap.get(e.key)! + 12 * this.kbOct;
            const data = new Uint8Array([
              parseInt("10000000", 2) + 1,
              noteval,
              0
            ]);
            this.highlightKey(noteval, "off", "self");
            this.midiOut?.send(data[0], [data[1], data[2]]);
            this.kbDownMap.set(e.key, false);
            this.dc?.send(data)

        }      
    })

    this.signalingServer = new WebSocket("wss://www.webduet.net:3435");
    this.signalingServer.onopen = () => {
    this.signalingServer!.send(JSON.stringify({
        type: "init",
        route: this.$route.params.roomId
      }))
      console.log("Webserver ready");
    };
    this.signalingServer.onmessage = (e) => {
      const data = JSON.parse(e.data).data;
      const msgType = JSON.parse(e.data).type;
      console.log(`Got message of type ${msgType}`);
      switch (msgType) {
        case "offer":         this.pc!.setRemoteDescription({ type: "offer", sdp: data })
                              .then(() => {
                                console.log("Remote description set, creating answer...")
                                return this.pc!.createAnswer();
                              })
                              .then((answer) => {
                                console.log("Created answer, setting local description...")
                                return this.pc!.setLocalDescription(answer);
                              })
                              .then(() => {
                                console.log("Local description set, waiting for ICE candidate...")
                                return this.candPromise;
                              })
                              .then(() => {
                                console.log("ICE candidates found, sending answer back...")
                                console.log("Answer: ", this.pc!.localDescription?.sdp)
                                this.signalingServer!.send(
                                  JSON.stringify({
                                    type: "answer",
                                    route: this.$route.params.roomId,
                                    data: this.pc!.localDescription?.sdp,
                                  })
                                );
                              })
                              break;

        case  "answer":       console.log("Received an answer from offerer");
                              console.log("Answer: ", data);
                              this.pc!.setRemoteDescription({ type: "answer", sdp: data })
                              .then(() => {
                                    console.log("Remote description set!");
                              });
                              break;

        case  "roomstatus":   this.roomStatusNotReceived = false;
                              if (data=="full") {
                                console.log("Room is full!")
                                this.roomStatusFull = true;
                              }
                              break;

        default:              console.log("Got unknown message type: ", msgType);
                              break;

                          
      }
    };



    const config =       {iceServers: [
       {urls: 'stun:stun.l.google.com:19302'}
   ]}
    this.pc = new RTCPeerConnection(config);
    this.pc.ondatachannel = (e) => {
      console.log("Data channel opened");
      this.dc = e.channel;
      this.dc.onopen = () => {this.connecting = false; this.connected = true; console.log("I AM ALIVE");}
      this.dc.onmessage = this.handleMidiEvent;
    };


    this.candPromise = new Promise<void>((resolve) => {
      this.pc!.onicecandidate = e => {
        if (e.candidate) {
          console.log("- Found ICE candidate: ")
          console.log(e.candidate);
        }
        else {
          console.log("Collected all ICE candidates!")
          resolve();
        }

      };
    });
  },
  methods: {
  addIceCandidate(candidate: RTCIceCandidate) {
    if (!this.addedCand) {
      this.pc!.addIceCandidate(candidate).then(() => {
        this.addedCand = true;
        console.log("- Added ICE candidate")
      })
    } else {
      console.log("- Already added ICE candidate earlier")
    }
  },
  svgLoaded(e: Event):void {
    this.octavesLoaded += 1;
    if (this.octavesLoaded == this.octaves) {
      const keyboard = document.getElementsByClassName("keys")[0]?.children;
      for (const span of keyboard) {
          const octave = span.id;
          const keys = span.getElementsByTagName("path");
          for (const key of keys) {
            key.style.animation = "pulse 0.5s ease-out";
            const nm = key.id + octave
            this.keyMap.set(WebMidi.noteNameToNumber(nm), key);
          }
      }
    }
  },
  highlightKey(n: number, state: string, player: string) {
    const key = this.keyMap.get(n);
    if (key) {
      switch (state) {
        case "on":  key.style.animation = `pulseon-${player} 3s ease-in-out infinite`;
                    break;

        case "off": if (key.id.includes("b")) {
                        key.style.animation = `pulseoffb-${player} 2.0s cubic-bezier(.11,.93,.26,.94)`;
                    } else {
                        key.style.animation = `pulseoffw-${player} 2.0s cubic-bezier(.11,.93,.26,.94)`;
                    }                    
                    break;
      }
    }
  },
  attachListener() {
    WebMidi.inputs.forEach(input => {
      input.removeListener();
    });

    this.midiIn?.addListener("midimessage", "all", (e) => {
      if (e.data.length > 0 && e.data[0] != 248 && e.data[0] != 254) { // Ignore clock tick and active sensing
        if (e.data.length == 3) {
            this.highlightKey(e.data[1], e.data[2] > 0 ? "on" : "off", "self");
        }
        if (this.dc && this.dc.readyState == "open") {
          console.log("input from: ", e)
          console.log("sending: ", e.data);
          this.dc.send(e.data);
        }
      }
    });
  },
  refreshDevices(first=false) {
    const oldInput = this.midiIn?.name ?? '';
    const oldOutput = this.midiOut?.name ?? '';

    WebMidi.disable();

    WebMidi.enable(() => {
        this.midiIns = WebMidi.inputs;
        console.log("Inputs:", this.midiIns);    
        this.midiOuts = WebMidi.outputs;
        console.log("Outputs:", this.midiOuts);
        this.matchInput(oldInput);
        this.matchOutput(oldOutput);
        if (first) {
            if (this.midiIns) {
              this.midiIn = this.midiIns[0];
            }
            if (this.midiIn) {
              this.matchOutput(this.midiIn.name);
            } else if (this.midiOuts) {
              this.midiOut = this.midiOuts[0];
            }
        }
        this.attachListener();
    });
  },
  matchOutput(name: string) {
    this.midiOuts.forEach(output => {
        if (output.name === name) {
          this.midiOut = output;
          return;
        }
    })
  },
  matchInput(name: string) {
    this.midiIns.forEach(input => {
        if (input.name === name) {
          this.midiIn = input;
          return;
        }
    })
  },
  async connect(): Promise<void> {
    if (this.connecting) {console.log("Already connecting..."); return;}
    console.log("Connecting...");
    this.connecting = true;
    this.dc = this.pc!.createDataChannel("chat", {});
    this.dc.onopen = () => {this.connecting = false; this.connected = true; console.log("I AM ALIVE");}
    this.dc.onmessage = this.handleMidiEvent;

    this.pc!.createOffer()
    .then(offer => {
      console.log("Created offer...")
      return this.pc!.setLocalDescription(offer);
    })
    .then(() => {
      console.log("Local description set")
      return this.candPromise
    })
    .then(() => {
      console.log("Local description set! Sending it to the other as offer...");
      console.log("Offer:", this.pc!.localDescription?.sdp)
      this.signalingServer!.send(
        JSON.stringify({
          type: "offer",
          route: this.$route.params.roomId,
          data: this.pc!.localDescription?.sdp,
        })
      );
    })

  },
  status(): void {
    console.log(this.pc!.signalingState);
    console.log(this.dc);
  },
  test(): void {
    this.dc!.send("brotato");
  },
  midiTest(): void {
    console.log("sending note...");
    this.midiOut!.playNote("C3", 1, { duration: 1000 });
  },
  handleMidiEvent(e: MessageEvent) {
    const data = new Uint8Array(e.data);
    console.log("MIDI event:" + data);
    switch (data.length) {
      case 1:
        this.midiOut!.send(data[0]);
        break;
      case 2:
        this.midiOut!.send(data[0], [data[1]]);
        break;
      case 3:
        this.highlightKey(data[1], data[2] > 0 ? "on" : "off", "other");
        this.midiOut!.send(data[0], [data[1], data[2]]);
        break;
      default:
        console.log("Invalid midi data!");
    }
  }
  }
});
